import React from "react";

export default function Footer() {
    return (
        <footer className="p-4 bg-gray-200 text-white text-center z-10">
            <p className="text-black">© 2024 Flavor Lab. All rights reserved.</p>
        </footer>
    );
}
